export const paths = {
  home: '/',
  signer: '/signer',
  verifier: '/verifier',
  terms: '/terms',
  privacy: '/privacy',
  imprint: '/imprint',
};
